webpackJsonp([200346936593618],{

/***/ 85:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactJss = __webpack_require__(13);
	
	var _reactJss2 = _interopRequireDefault(_reactJss);
	
	var _const = __webpack_require__(59);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Divider = function Divider(_ref) {
	    var classes = _ref.classes;
	
	    return _react2.default.createElement(
	        'div',
	        { className: classes.container },
	        _react2.default.createElement('div', { className: classes.divider })
	    );
	};
	
	var styles = {
	    container: {
	        maxWidth: function maxWidth(_ref2) {
	            var _ref2$maxWidth = _ref2.maxWidth,
	                _maxWidth = _ref2$maxWidth === undefined ? _const.layoutMaxWidth : _ref2$maxWidth;
	
	            return _maxWidth;
	        },
	        margin: '0 auto'
	    },
	    divider: {
	        width: function width(_ref3) {
	            var _ref3$width = _ref3.width,
	                _width = _ref3$width === undefined ? '50%' : _ref3$width;
	
	            return _width;
	        },
	        height: function height(_ref4) {
	            var _ref4$stroke = _ref4.stroke,
	                stroke = _ref4$stroke === undefined ? 1 : _ref4$stroke;
	            return stroke;
	        },
	        margin: '0 auto',
	        backgroundColor: function backgroundColor(_ref5) {
	            var _ref5$color = _ref5.color,
	                color = _ref5$color === undefined ? 'black' : _ref5$color;
	            return color;
	        }
	    }
	};
	
	exports.default = (0, _reactJss2.default)(styles)(Divider);
	module.exports = exports['default'];

/***/ }),

/***/ 21:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(50);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Link = function Link(_ref) {
	    var children = _ref.children,
	        to = _ref.to,
	        other = _objectWithoutProperties(_ref, ['children', 'to']);
	
	    var internal = /^\/(?!\/)/.test(to);
	
	    if (internal) {
	        return _react2.default.createElement(
	            _gatsbyLink2.default,
	            _extends({ to: to }, other),
	            children
	        );
	    }
	    return _react2.default.createElement(
	        'a',
	        _extends({ href: to }, other),
	        children
	    );
	};
	
	exports.default = Link;
	module.exports = exports['default'];

/***/ }),

/***/ 229:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactJss = __webpack_require__(13);
	
	var _reactJss2 = _interopRequireDefault(_reactJss);
	
	var _gatsbyImage = __webpack_require__(36);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _BackgroundImageSection = __webpack_require__(57);
	
	var _BackgroundImageSection2 = _interopRequireDefault(_BackgroundImageSection);
	
	var _Section = __webpack_require__(58);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _Link = __webpack_require__(21);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _Divider = __webpack_require__(85);
	
	var _Divider2 = _interopRequireDefault(_Divider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = {
	    sectionProducts: {
	        marginBottom: '1.8rem',
	        display: 'flex',
	        flexDirection: 'column',
	        alignItems: 'center',
	        '& > h3': {
	            marginBottom: '4rem'
	        }
	    },
	    products: {
	        display: 'flex',
	        flexWrap: 'wrap',
	        justifyContent: 'center'
	    },
	    product: {
	        display: 'inline-flex',
	        flexDirection: 'column',
	        alignItems: 'center',
	        '& h3': {
	            fontSize: '1.58rem',
	            marginBottom: '1rem'
	        }
	    },
	    links: {
	        display: 'inline-flex',
	        margin: '0 2.8rem'
	    },
	    sectionDemos: {
	        paddingBottom: '10rem',
	        display: 'flex',
	        flexDirection: 'column',
	        alignItems: 'center',
	        '& > h3': {
	            marginBottom: '6rem'
	        }
	    },
	    demo: {
	        margin: '1.88rem 0',
	        width: '90%',
	        display: 'flex',
	        flexWrap: 'wrap',
	        justifyContent: 'center'
	    },
	    thumbnail: {
	        width: '20%', //'12.05rem',
	        margin: '0 0.94rem 1rem 0'
	    },
	    detail: {
	        width: '30%',
	        flexGrow: 2,
	        margin: '0 0.94rem'
	    },
	    title: {
	        width: '100%',
	        display: 'inline-flex',
	        flexWrap: 'wrap',
	        alignItems: 'center',
	        '& h3': {
	            margin: '0.5rem 0 0.5rem 0',
	            fontSize: '1.59rem'
	        }
	    },
	    download: {
	        marginLeft: 'auto',
	        '& > button': {
	            fontSize: '0.94rem',
	            width: '7.12em',
	            height: '1.44em',
	            border: 'none',
	            color: '#F4FFF6',
	            backgroundColor: '#3F3F3F',
	            borderRadius: '0.7em'
	        }
	    },
	    '@media only screen and (max-width: 768px)': {
	        demo: {
	            flexDirection: 'column',
	            alignItems: 'center'
	        },
	        thumbnail: {
	            width: '100%'
	        },
	        detail: {
	            width: '100%'
	        }
	    }
	};
	
	exports.default = (0, _reactJss2.default)(styles)(function (_ref) {
	    var classes = _ref.classes,
	        data = _ref.data;
	
	    var products = [{
	        name: data.contents.downloads.products.client,
	        links: [{
	            sizes: data.imageOculus.childImageSharp.sizes,
	            to: data.contents.downloads.products.urlOculus
	        }, {
	            sizes: data.imageGoogleVR.childImageSharp.sizes,
	            to: data.contents.downloads.products.urlGoogleVR
	        }]
	    }, {
	        name: data.contents.downloads.products.server,
	        links: [{
	            sizes: data.imageUnity.childImageSharp.sizes,
	            to: data.contents.downloads.products.urlUnity
	        }, {
	            sizes: data.imageUE4.childImageSharp.sizes,
	            to: data.contents.downloads.products.urlUE4
	        }]
	    }].map(function (product, index) {
	        return _react2.default.createElement(
	            'div',
	            { key: index, className: classes.product },
	            _react2.default.createElement(
	                'h3',
	                null,
	                product.name
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: classes.links },
	                product.links.map(function (link, index) {
	                    return _react2.default.createElement(
	                        _Link2.default,
	                        { key: index, to: link.to },
	                        _react2.default.createElement(_gatsbyImage2.default, {
	                            style: { width: '8.82rem' },
	                            sizes: link.sizes
	                        })
	                    );
	                })
	            )
	        );
	    });
	
	    var demos = data.demos.edges.map(function (demo, index) {
	        var sizes = void 0;
	        data.thumbnails.edges.some(function (thumbnail) {
	            if (demo.node.frontmatter.thumbnail === thumbnail.node.name) {
	                sizes = thumbnail.node.childImageSharp.sizes;
	                return true;
	            }
	            return false;
	        });
	
	        return _react2.default.createElement(
	            'div',
	            { key: index, className: classes.demo },
	            _react2.default.createElement(_gatsbyImage2.default, {
	                outerWrapperClassName: classes.thumbnail,
	                sizes: sizes
	            }),
	            _react2.default.createElement(
	                'div',
	                { className: classes.detail },
	                _react2.default.createElement(
	                    'div',
	                    { className: classes.title },
	                    _react2.default.createElement(
	                        'h3',
	                        null,
	                        demo.node.frontmatter.title
	                    ),
	                    _react2.default.createElement(
	                        _Link2.default,
	                        {
	                            className: classes.download,
	                            to: demo.node.frontmatter.download },
	                        _react2.default.createElement(
	                            'button',
	                            null,
	                            'Download'
	                        )
	                    )
	                ),
	                _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: demo.node.html } })
	            )
	        );
	    });
	
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            _BackgroundImageSection2.default,
	            {
	                sizesBackground: data.imageBackground.childImageSharp.sizes },
	            _react2.default.createElement(
	                'h1',
	                null,
	                data.contents.downloads.title
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                data.contents.downloads.description
	            )
	        ),
	        _react2.default.createElement(
	            _Section2.default,
	            { className: classes.sectionProducts },
	            _react2.default.createElement(
	                'h3',
	                null,
	                data.contents.downloads.products.header
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: classes.products },
	                products
	            )
	        ),
	        _react2.default.createElement(_Divider2.default, { width: '90%' }),
	        _react2.default.createElement(
	            _Section2.default,
	            { className: classes.sectionDemos },
	            _react2.default.createElement(
	                'h3',
	                null,
	                data.contents.downloads.demos.header
	            ),
	            demos
	        )
	    );
	});
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-downloads-js-aabc3e1a91f1eb4ebf39.js